import { BOARD, BOARD_TERM, COUNCIL, IMAGES } from "../../lib/ablemp-data";

export const Governance = () => {
  const [president, ...councilMembers] = COUNCIL;

  return (
    <section
      id="governanca"
      data-testid="governance-section"
      className="relative bg-[#0A0F14] text-white py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grain-dark opacity-50 pointer-events-none" />
      {/* Decorative coin imagery on the side */}
      <div className="absolute inset-y-0 right-0 w-1/3 hidden lg:block pointer-events-none">
        <img
          src={IMAGES.realCoins}
          alt=""
          className="w-full h-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent to-[#0A0F14]" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 text-[11px] uppercase tracking-[0.3em] text-white/55">
          <span className="flag-rule" aria-hidden />
          <span>Governança Institucional</span>
        </div>

        <div className="mt-10 grid grid-cols-12 gap-8 items-end">
          <h2
            data-testid="governance-headline"
            className="col-span-12 lg:col-span-9 font-serif-display text-[36px] sm:text-[52px] lg:text-[80px] leading-[1.02] tracking-[-0.02em]"
          >
            Conselho e{" "}
            <span className="italic font-light text-[#FEDF00]">Diretoria</span>.
          </h2>
          <p className="col-span-12 lg:col-span-3 text-white/70 text-base leading-relaxed">
            Estrutura colegiada que conduz a missão da ABLEMP com transparência
            e responsabilidade pública.
          </p>
        </div>

        {/* Conselho Deliberativo */}
        <div className="mt-20">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <h3 className="font-serif-display text-2xl md:text-3xl">
              Conselho Deliberativo
            </h3>
            <span className="text-[11px] uppercase tracking-[0.3em] text-white/45">
              08 membros
            </span>
          </div>

          {/* President highlight */}
          <div
            data-testid="council-president"
            className="mt-8 border border-white/15 bg-[#131C24] p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
          >
            <div className="flex items-center gap-6">
              <div className="h-16 w-16 grid place-items-center border border-[#FEDF00] text-[#FEDF00] font-serif-display text-2xl">
                {president.name
                  .split(" ")
                  .filter((s) => s.length > 2)
                  .slice(0, 2)
                  .map((w) => w[0])
                  .join("")}
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#FEDF00]">
                  {president.role}
                </div>
                <div className="mt-2 font-serif-display text-2xl md:text-3xl leading-tight">
                  {president.name}
                </div>
              </div>
            </div>
            <div className="hidden md:flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-white/40">
              <span>Presidência</span>
              <span className="h-px w-12 bg-[#FEDF00]" />
            </div>
          </div>

          {/* Council members */}
          <ul className="mt-px grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {councilMembers.map((m, i) => (
              <li
                key={m.name}
                data-testid={`council-member-${i}`}
                className="bg-[#0A0F14] hover:bg-[#131C24] transition-colors p-6 md:p-7 group"
              >
                <div className="flex items-center justify-between">
                  <span className="font-serif-display text-xl text-[#009B3A]">
                    0{i + 2}
                  </span>
                  <span className="h-px w-6 bg-white/20 group-hover:w-10 group-hover:bg-[#FEDF00] transition-all" />
                </div>
                <div className="mt-5 font-serif-display text-lg md:text-xl leading-tight">
                  {m.name}
                </div>
                <div className="mt-2 text-[10px] uppercase tracking-[0.3em] text-white/55">
                  {m.role}
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Diretoria */}
        <div className="mt-24">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div>
              <h3 className="font-serif-display text-2xl md:text-3xl">
                Diretoria
              </h3>
              <div className="mt-2 text-[11px] uppercase tracking-[0.3em] text-[#FEDF00]">
                {BOARD_TERM}
              </div>
            </div>
            <span className="text-[11px] uppercase tracking-[0.3em] text-white/45">
              06 diretores
            </span>
          </div>

          <ul className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {BOARD.map((m, i) => (
              <li
                key={m.name}
                data-testid={`board-member-${i}`}
                className={`bg-[#0A0F14] hover:bg-[#131C24] transition-colors p-7 md:p-8 group ${
                  i === 0 ? "lg:col-span-3" : ""
                }`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`font-serif-display ${
                      i === 0 ? "text-3xl text-[#FEDF00]" : "text-xl text-[#009B3A]"
                    }`}
                  >
                    0{i + 1}
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.3em] text-white/45">
                    {m.role}
                  </span>
                </div>
                <div
                  className={`mt-6 font-serif-display leading-tight ${
                    i === 0
                      ? "text-2xl md:text-3xl"
                      : "text-lg md:text-xl"
                  }`}
                >
                  {m.name}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Governance;
